import React, { Component } from 'react';

import {
    Box,
    Grid,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Slide,
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    TextField,
} from  '@mui/material';

import CloseIcon from '@mui/icons-material/Close';

function Transition(props) {
    return <Slide direction="up" {...props} />;
}


class UserUpdatePassword extends Component {
    state = { 
        password: "",
        confirm_password: "",
        errors:{
            password: "",
            confirm_password: "",
        }
    }
    handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value
        
        if(name === "password"){
            this.validPassword(value)
        }
        this.setState({
            [name]: value
        })
        
    }

    validPassword = (password) => {
        let isValid = true
        let re = /[0-9]/;
        if(!re.test(password)) {
            isValid = false
        }
        re = /[a-z]/;
        if(!re.test(password)) {
            isValid = false
        }
        re = /[A-z]/;
        if(!re.test(password)) {
            isValid = false
        }
        if(password.length < 6){
            isValid = false
        }

        return isValid;
    }
    
    validate = () => {
        let required = [
            "password",
            "confirm_password",
        ]
        
        let noError = true
        let errors = {}

       
        required.map(field => {
            if(!this.state[field]){
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })

        if (this.state.password) {
            let isValid = this.validPassword(this.state.password);
            if (!isValid){
                errors.password =  "Le mot de passe doit contenir au minimum 6 caractères dont un chiffre, une majuscule et une minuscule"
                noError = false
            } else if (this.state.password !== this.state.confirm_password){
                errors.confirm_password =  "Le mot de passe et sa confirmation doivent être identiques"
                noError = false
            } else {
                errors.password = ""   
            }

        }
        this.setState({
            errors
        })
    
        return noError
    }
    handleSubmit = async () => {
        let data = Object.assign({}, this.props.user, {
            user_password : this.state.password,
            user_update_date: new Date(),
        })

        console.log('====================================');
        console.log({data, user: this.props.user});
        console.log('====================================');
        if(this.validate()){
            await this.props.updateUserPassword(data)  

            if(this.props.STATE.users.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.users.error}`)
            } else{
                this.props.notif("success","Le mot de passe a été modifié avec succès")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs" )
        }
    }
    render() {
        console.log('====================================');
        console.log({user: this.props.user});
        console.log('====================================');
        return(
            <Dialog
                open={this.props.open}
                onClose={(_, reason) => {reason !== "backdropClick" && this.props.handleClose()} }
                aria-labelledby="form-dialog-title"
                fullWidth
                maxWidth="sm"
                TransitionComponent={Transition}
                scroll="body"
            >
                <AppBar style={{position: 'relative'}} color="secondary">
                    <Toolbar>
                        <IconButton color="inherit" onClick={this.props.handleClose} aria-label="Close">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" color="inherit">
                            Modifier le mot de passe
                        </Typography>
                    </Toolbar>
                </AppBar>
           
                <DialogContent  style={{overflow: "hidden"}}> 
                    <Box p={3}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    style={{width:"100%"}}
                                    type="password"
                                    required
                                    variant="outlined"  
                                    name="password" 
                                    id="password" 
                                    value={this.state.password} 
                                    label="Mot de passe" 
                                    placeholder="Mot de passe" 
                                    error={!!this.state.errors.password} 
                                    helperText={this.state.errors.password} 
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            
                            <Grid item xs={12}>
                                <TextField
                                    style={{width:"100%"}}
                                    type="password"
                                    required
                                    variant="outlined"  
                                    name="confirm_password" 
                                    id="confirm_password" 
                                    value={this.state.confirm_password} 
                                    label="Confirmer le Mot de Passe" 
                                    placeholder="Confirmer le Mot de Passe" 
                                    error={!!this.state.errors.confirm_password} 
                                    helperText={this.state.errors.confirm_password} 
                                    onChange={this.handleChange}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button 
                        variant="contained" 
                        onClick={this.handleSubmit} 
                        color="secondary" 
                        disabled={this.props.STATE.users.fetching}
                    >
                        Modifier
                    </Button>
                    <Button onClick={this.props.handleClose} >
                        Annuler
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default UserUpdatePassword;